export default "__VITE_ASSET__C$65lxlX__"